var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 327.47 34.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#655546;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.36,23.57a39.8,39.8,0,0,1,5.75-6,64.32,64.32,0,0,1,6.67-5A74.81,74.81,0,0,1,234.8,5,82.73,82.73,0,0,1,268.25.15a88,88,0,0,1,32.59,8.36,83.8,83.8,0,0,1,26.63,19.41c-2.7-.72-5.25-1.6-7.79-2.45-1.3-.37-2.57-.79-3.84-1.19s-2.49-.87-3.77-1.2l-3.77-1.14c-.63-.18-1.23-.41-1.86-.58l-1.88-.51c-1.26-.33-2.49-.7-3.72-1.06s-2.51-.59-3.74-.93a162.44,162.44,0,0,0-29.67-4.74,138.85,138.85,0,0,0-29.8,1.49A159.86,159.86,0,0,0,207.36,23.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,34.68A39.81,39.81,0,0,1,4.92,28a67.19,67.19,0,0,1,5.95-5.86,76.38,76.38,0,0,1,13.91-9.41A82.78,82.78,0,0,1,57.31,3.53a88,88,0,0,1,33.4,4,83.94,83.94,0,0,1,28.94,15.77c-2.77-.36-5.42-.9-8.05-1.41-1.33-.2-2.64-.45-3.95-.68s-2.58-.54-3.9-.7l-3.88-.64c-.65-.09-1.28-.24-1.93-.33L96,19.32c-1.29-.17-2.56-.37-3.83-.57s-2.56-.26-3.82-.43a161,161,0,0,0-30-.83A138.44,138.44,0,0,0,29,22.85,160.58,160.58,0,0,0,0,34.68Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset5);
export default __webpack_public_path__ + "static/media/Asset 5.99610fbc.svg";
export { ForwardRef as ReactComponent };